// extracted by mini-css-extract-plugin
export default {"chatContainer":"styles_chatContainer__1VMZI","empty":"styles_empty__CFCGd","slide-in-bottom":"styles_slide-in-bottom__-odxY"};